import * as React from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import { NavPath } from '../../paths';
import "./bottomNav.less";

export interface BottomNavProps {
}

export const BottomNav = (props: BottomNavProps) => {


    return <div className="bottom-nav">
        <Switch>
            <Route path={NavPath.who} exact>
                <span></span>
                <Link to={NavPath.what}>To Budget</Link>
            </Route>
            <Route path={NavPath.what} exact >
                <Link to={NavPath.who}>Change Info</Link>
                <Link to={NavPath.breakdown}>View Targets</Link>
            </Route>
            <Route path={NavPath.breakdown} exact>
                <Link to={NavPath.what}>Change Budget</Link>
                <Link to={NavPath.outcomes}>View Outcomes</Link>
            </Route>
            <Route path={NavPath.outcomes} exact>
                <Link to={NavPath.breakdown}>Back to Targets</Link>
                {/* <Link to={""}>Export PDF</Link> */}
                <span></span>
            </Route>
        </Switch>

    </div>

}